import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'tobacco-alcohol',
  templateUrl: './tobacco-alcohol.component.html',
})
export class TobaccoAlcoholComponent {

  title = 'tobaccoAlcohol.title';
  isStaff = this.store.state.isStaff;
  progressBar = this.progress.tobaccoAlcohol;
  tobacco: boolean = this.store.state.consent.student.tobacco;
  alcohol: boolean = this.store.state.consent.student.alcohol;

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  disabled(): boolean {
    if (this.tobacco !== null && this.alcohol !== null)
      return true;
  }

  back() {
    this.router.navigate([this.navigation.tobaccoAlcohol.back]);
  }

  next() {
    this.store.state.consent.student.tobacco = this.tobacco;
    this.store.state.consent.student.alcohol = this.alcohol;
    this.router.navigate([this.navigation.tobaccoAlcohol.next]);
  }
}
